import { Box, Typography } from "@mui/material";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid";
import { useCallback, useEffect, useRef, useState } from "react";
import LoadingIndicator from "../components/LoadingIndicator";
import ContractsTable from "../components/Contracts/ContractsTable";
import { PaginationModel, QueryOptions } from "../interfaces/pagination";
import { Contract } from "../interfaces/contract";
import { useAllContracts } from "../services/contracts";
import PageTitle from "../components/PageTitle";

const ContractsPage = () => {
  const [contracts, setContracts] = useState<Contract[]>([]);
  // const [isLoading, setIsLoading] = useState<boolean>(true);

  const [paginationModel, setPaginationModel] = useState<PaginationModel>({
    page: 0,
    pageSize: 25,
  });

  const [rowCount, setRowCount] = useState<number>(contracts.length);

  const [queryOptions, setQueryOptions] = useState<QueryOptions>({});

  const timeoutRef = useRef<number | null>(null);

  const handleFilterModelChange = useCallback(
    (filterModel: GridFilterModel) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = window.setTimeout(() => {
        setQueryOptions((prev) => {
          if (
            filterModel.quickFilterValues &&
            filterModel.quickFilterValues.length > 0
          ) {
            setPaginationModel((prev) => ({
              ...prev,
              page: 0,
            }));

            const search = filterModel.quickFilterValues.join(" ");
            return { ...prev, search };
          } else {
            const { search, ...others } = prev;
            return others;
          }
        });
      }, 300);
    },
    []
  );

  const handleSortModelChange = useCallback((sortModel: GridSortModel) => {
    setQueryOptions((prev) => {
      if (sortModel.length > 0) {
        setPaginationModel((prev) => ({
          ...prev,
          page: 0,
        }));

        const ordering = `${sortModel[0].sort === "desc" ? "-" : ""}${
          sortModel[0].field
        }`;
        return { ...prev, ordering };
      } else {
        const { ordering, ...others } = prev;
        return others;
      }
    });
  }, []);

  const {
    data: contractsData,
    mutate,
    isLoading,
  } = useAllContracts({
    ...paginationModel,
    ...queryOptions,
  });

  const refreshContracts = () => {
    mutate();
  }

  useEffect(() => {
    setContracts(contractsData?.results || []);

    setRowCount((prevRowCount) => (contractsData ? contractsData.count : prevRowCount));
  }, [contractsData]);

  return (
    <>
      <PageTitle title="Contracts"/>
      <Box sx={{}}>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <ContractsTable
            contracts={contracts}
            rowCount={rowCount}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleFilterModelChange={handleFilterModelChange}
            handleSortModelChange={handleSortModelChange}
            isLoading={isLoading}
            refreshContracts={refreshContracts}
          />
        )}
      </Box>
    </>
  );
};

export default ContractsPage;
